import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
 
import SecondaryHeader from "olive-react-myoneui/lib/SecondaryHeader"; 
import Pageview from "./Pageview"; 
import TopHeader from "../TopHeader";
import { setCart } from "../../reducers/cartSlice";
import { useSelector, useDispatch } from "react-redux";


function Custom_page(page_details) { 
  const dispatch = useDispatch();

  let url = window.location.href
  url = new URL(url);
  let searchParams = new URLSearchParams(url.search);
  let param = searchParams.get('clear_cart')
 
  // console.log(typeof param);

  useEffect(() => {
    if(param == "1"){
      dispatch(setCart({ cartCount: 0 }));
      localStorage.setItem("mycart_count", 0);
      localStorage.setItem('mycart','{}');
    }
    
  }, []);
  

  const location = useLocation();  
  const [module, setModule] = useState({ name: "loading", param: {} });   
  const page_content = page_details.page_details?.page_content?.p_customized_content ? (JSON.parse(page_details.page_details?.page_content?.p_customized_content)) : ''; 
  const asset_url = page_details.page_details?.content_box_asset_url; 
  const asset_url_data = (asset_url != undefined) ? asset_url : window.location.origin+'/assets/'; 
  const current_currency = page_details.page_details?.current_currency;
// console.log(asset_url_data);
  return (
    <>  
      <div className="dashboard-wrapper w-100"> 
          <Pageview page_content={page_content} 
                asset_url_data={asset_url_data} defaultCurrency={current_currency}>
                </Pageview>
      </div>
      
    </>
  );
}

export default Custom_page;
